import { put, takeLatest } from "redux-saga/effects";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import {
  GET_ALLOCATORS_DETAIL,
  GET_ALLOCATORS_DETAIL_INIT,
  GET_ALLOCATORS_DETAIL_SUCCESS,
  GET_ALLOCATORS_DETAIL_FAILED,
  FOLLOW_ALLOCATOR,
  FOLLOW_ALLOCATOR_INIT,
  FOLLOW_ALLOCATOR_SUCCESS,
  FOLLOW_ALLOCATOR_FAILED,
  CREATE_HEDGEFUND_AUDITLOGS,
  CREATE_HEDGEFUND_AUDITLOGS_INIT,
  CREATE_HEDGEFUND_AUDITLOGS_SUCCESS,
  CREATE_HEDGEFUND_AUDITLOGS_FAILED,
  GET_ALLOCATOR_USERS,
  GET_ALLOCATOR_USERS_INIT,
  GET_ALLOCATOR_USERS_SUCCESS,
  GET_ALLOCATOR_USERS_FAILED,
  GET_ALL_ADMIN_LIST,
  GET_ALL_ADMIN_LIST_INIT,
  GET_ALL_ADMIN_LIST_SUCCESS,
  GET_ALL_ADMIN_LIST_FAILED,
  GET_HEDGEFUND_USERS_INIT,
  GET_HEDGEFUND_USERS_SUCCESS,
  GET_HEDGEFUND_USERS_FAILED,
  GET_HEDGEFUND_USERS,
  CREATE_APPOINTMENT_REQUEST,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_FAILED,
  CREATE_APPOINTMENT_ACTION,
  HEDGEFUND_CONNECTION_INIT,
  HEDGEFUND_CONNECTION_SUCCESS,
  HEDGEFUND_CONNECTION_FAILED,
  HEDGEFUND_CONNECTION,
  GET_ALLOCATOR_INFO_INIT,
  GET_ALLOCATOR_INFO_SUCCESS,
  GET_ALLOCATOR_INFO_FAILED,
  GET_ALLOCATOR_INFO,
  GET_ALLOCATOR_USER_LIST_INIT,
  GET_ALLOCATOR_USER_LIST_SUCCESS,
  GET_ALLOCATOR_USER_LIST_FAILED,
  GET_ALLOCATOR_USER_LIST
} from "./constants";

export function* allocatorDetails({ id }) {
  yield put({ type: GET_ALLOCATORS_DETAIL_INIT });
  try {
    const res = yield getUtil(`${API.AllocatorDetail}?Id=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_ALLOCATORS_DETAIL_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_ALLOCATORS_DETAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* followAllocator({ allocatorId, follow, onSuccess }) {
  const payload = {
    allocatorId,
    follow,
  };
  yield put({ type: FOLLOW_ALLOCATOR_INIT });
  try {
    const res = yield postUtil(API.FollowAllocator, payload);
    if (res?.status === 200) {
      if (onSuccess) onSuccess();
      yield put({
        type: FOLLOW_ALLOCATOR_SUCCESS,
        payload: { allocatorId, follow },
      });
    } else {
      yield put({ type: FOLLOW_ALLOCATOR_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* CreateAuditLogs({ payload }) {
  yield put({ type: CREATE_HEDGEFUND_AUDITLOGS_INIT });
  try {
    const res = yield postUtil(API.CreateAuditLogs , payload, window._env_.CHAT_API_URL);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: CREATE_HEDGEFUND_AUDITLOGS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: CREATE_HEDGEFUND_AUDITLOGS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getFCNTenants() {
  yield put({ type: GET_ALL_ADMIN_LIST_INIT });
  try {
    const res = yield getUtil(API.fcnAdminList);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALL_ADMIN_LIST_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALL_ADMIN_LIST_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getAllocatorUsers( { id } ) {
  try {
      yield put({ type: GET_ALLOCATOR_USERS_INIT });

      const res = yield getUtil(`${API.GetCompanyUsers}?id=${id}`);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: GET_ALLOCATOR_USERS_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: GET_ALLOCATOR_USERS_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}
export function* getHedgeFundUsers() {
  try {
      yield put({ type: GET_HEDGEFUND_USERS_INIT });

      const res = yield getUtil(API.GetHedgeFundUsers);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: GET_HEDGEFUND_USERS_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: GET_HEDGEFUND_USERS_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}

export function* appointmentCreation({ payload, onSuccess }) {
  yield put({ type: CREATE_APPOINTMENT_REQUEST });
  try {
    const res = yield postUtil(`${API.CreateAppointment}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: CREATE_APPOINTMENT_SUCCESS,
        payload: data.result,
      });
      onSuccess(data.result.id);
    } else {
      yield put({ type: CREATE_APPOINTMENT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* isHedgeFundSchedule( { tenantId } ) {
  try {
      yield put({ type: HEDGEFUND_CONNECTION_INIT });

      const res = yield getUtil(`${API.HedgefundConnection}?tenantId=${tenantId}`);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: HEDGEFUND_CONNECTION_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: HEDGEFUND_CONNECTION_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}

export function* getAllocatorInfoSaga({ id }) {
  yield put({ type: GET_ALLOCATOR_INFO_INIT });
  try {
    const res = yield getUtil(`${API.GetAllocatorInfo}?Id=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_ALLOCATOR_INFO_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_ALLOCATOR_INFO_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getAllocatorUserListSaga( { id } ) {
  try {
      yield put({ type: GET_ALLOCATOR_USER_LIST_INIT });

      const res = yield getUtil(`${API.GetCompanyUsers}?id=${id}`);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: GET_ALLOCATOR_USER_LIST_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: GET_ALLOCATOR_USER_LIST_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}
export function* allocatorDetail() {
  yield takeLatest(GET_ALLOCATORS_DETAIL, allocatorDetails);
  yield takeLatest(FOLLOW_ALLOCATOR, followAllocator);
  yield takeLatest(CREATE_HEDGEFUND_AUDITLOGS, CreateAuditLogs);
  yield takeLatest(GET_ALL_ADMIN_LIST, getFCNTenants);
  yield takeLatest(GET_ALLOCATOR_USERS, getAllocatorUsers);
  yield takeLatest(GET_HEDGEFUND_USERS, getHedgeFundUsers);
  yield takeLatest(CREATE_APPOINTMENT_ACTION, appointmentCreation);
  yield takeLatest(HEDGEFUND_CONNECTION, isHedgeFundSchedule);
  yield takeLatest(GET_ALLOCATOR_INFO, getAllocatorInfoSaga);
  yield takeLatest(GET_ALLOCATOR_USER_LIST, getAllocatorUserListSaga);
}
